export enum FormActionType {
    CreateMeeting,
    UpdateMeeting,
}
